import {fetchAuthorized} from "@atg-shared/auth";
import {
    TEAM_CHAT_SERVICE_URL,
    TEAM_CHAT_PUBLIC_SERVICE_URL,
} from "@atg-shared/service-url";
import {TeamChatUtils} from "@atg-tillsammans/team-chat-utils";

import type {ChannelId, AuthorType} from "@atg-tillsammans-shared/chat-types";

export const fetchChannelHistory = (channelId: ChannelId, page: number) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/history?page=${page}`,
        undefined,
        {
            memberFlowEnabled: false,
            fallbackUrl: `${TEAM_CHAT_PUBLIC_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
                channelId,
            )}/history?page=${page}`,
        },
    );

export const fetchMyChannelStats = (channelId: ChannelId) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/stats`,
        undefined,
        {
            memberFlowEnabled: false,
        },
    );

export const postMessage = (channelId: ChannelId, text: string, authorType: AuthorType) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/comments`,
        {
            method: "POST",
            body: JSON.stringify({
                text,
                authorType,
            }),
        },
    );

export const saveMessage = (
    channelId: ChannelId,
    commentId: number,
    messageText: string,
    authorType: AuthorType,
) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/comments/${commentId}`,
        {
            method: "PUT",
            body: JSON.stringify({
                text: messageText,
                authorType,
            }),
        },
    );

export const removeMessage = (channelId: ChannelId, commentId: number) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/comments/${commentId}`,
        {
            method: "DELETE",
        },
    );

export const reportMessage = (channelId: ChannelId, commentId: number, text: string) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/comments/${commentId}/report`,
        {
            method: "POST",
            body: JSON.stringify({
                text,
            }),
        },
    );

export const blockMember = (channelId: ChannelId, commentId: number) =>
    fetchAuthorized(
        `${TEAM_CHAT_SERVICE_URL}/channels/${TeamChatUtils.channelIdToString(
            channelId,
        )}/block/${commentId}`,
        {
            method: "POST",
        },
    );
